export default __webpack_public_path__ + "static/media/Asset186.b48a033d.svg";